import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77d9b992"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sc-logo" }, "SECOND CORNER", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CSidebarBrand = _resolveComponent("CSidebarBrand")!
  const _component_AppSidebarNav = _resolveComponent("AppSidebarNav")!
  const _component_CSidebarToggler = _resolveComponent("CSidebarToggler")!
  const _component_CSidebar = _resolveComponent("CSidebar")!

  return (_openBlock(), _createBlock(_component_CSidebar, {
    position: "fixed",
    selfHiding: "md",
    unfoldable: $setup.sidebarUnfoldable,
    visible: $setup.sidebarVisible,
    onVisibleChange: _cache[1] || (_cache[1] = 
      (event) =>
        _ctx.$store.commit({
          type: 'updateSidebarVisible',
          value: event,
        })
    )
  }, {
    default: _withCtx(() => [
      _createVNode(_component_CSidebarBrand, null, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(_component_AppSidebarNav),
      _createVNode(_component_CSidebarToggler, {
        class: "d-none d-lg-flex",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$store.commit('toggleUnfoldable')))
      })
    ]),
    _: 1
  }, 8, ["unfoldable", "visible"]))
}